import { FC } from "react";
import { useTranslation } from "react-i18next";

import { LandingLayout, LoaderMuiLanding } from "@ryde/controls-landing";
import {
  CompanyScopeLandingsContextWrapper,
  useLandingInit,
} from "@ryde/utils-landings";

import { GenericLandingWrapper } from "./generic-landing-wrapper.styled";

interface IGenericLandingPage {
  companyId: number;
}

export const GenericLandingPage: FC<IGenericLandingPage> = ({ companyId }) => {
  const { t } = useTranslation();
  const { landingInitData, isLoading } = useLandingInit({ companyId });
  return (
    <>
      {landingInitData && (
        <CompanyScopeLandingsContextWrapper
          companyId={landingInitData.companyId}
          isDynamicLandingPage={true}
        >
          <GenericLandingWrapper>
            <LandingLayout />
          </GenericLandingWrapper>
        </CompanyScopeLandingsContextWrapper>
      )}
      {isLoading && <LoaderMuiLanding loading text={t("ui.LOADING_DATA")} />}
    </>
  );
};
